import React from 'react';
import { Button, Type } from './button';
import { createStyles } from '@/contexts/theme-context';
import { SCREEN_PADDING } from '@/styles';
import { StyleProp, View, ViewStyle } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  contentContainerStyle?: StyleProp<ViewStyle>;
  loading?: boolean;
  message: string;
  onPrimaryButtonPress: () => void;
  onSecondaryButtonPress: () => void;
  primaryButtonLabel: string;
  primaryButtonTrackingData: TrackingData | null;
  primaryButtonType?: Type;
  secondaryButtonLabel: string;
  secondaryButtonTrackingData: TrackingData | null;
  title: string;
}

export const ConfirmationActionContent: React.FC<Props> = ({
  contentContainerStyle,
  loading = false,
  message,
  onPrimaryButtonPress,
  onSecondaryButtonPress,
  primaryButtonLabel,
  primaryButtonType = 'primary',
  primaryButtonTrackingData,
  secondaryButtonLabel,
  secondaryButtonTrackingData,
  title,
}) => {
  const { isSmallLayout } = useLayoutContext();
  const [styles] = useStyles();
  return (
    <View style={[styles.base, contentContainerStyle]}>
      <View style={styles.titleWrapper}>
        <Typography variant="heading-lg">{title}</Typography>
      </View>
      <View style={styles.messageWrapper}>
        <Typography variant="paragraph-base">{message}</Typography>
      </View>
      <View style={styles.actionButtonsWrapper}>
        <Button
          loading={loading}
          onPress={onPrimaryButtonPress}
          style={
            primaryButtonType === 'danger' ? styles.dangerButton : undefined
          }
          textStyle={
            primaryButtonType === 'danger' ? styles.dangerButtonText : undefined
          }
          trackingData={primaryButtonTrackingData}
          type={primaryButtonType}
        >
          {primaryButtonLabel}
        </Button>
        {isSmallLayout ? (
          <Button
            onPress={onSecondaryButtonPress}
            trackingData={secondaryButtonTrackingData}
            type="secondary"
          >
            {secondaryButtonLabel}
          </Button>
        ) : null}
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  actionButtonsWrapper: {
    gap: 8,
  },
  base: {
    paddingHorizontal: SCREEN_PADDING,
  },
  dangerButton: {
    backgroundColor: theme.sk.color.text.error,
    borderColor: theme.sk.color.text.error,
  },
  dangerButtonText: {
    color: theme.sk.color.text.ondark,
  },
  messageWrapper: {
    marginBottom: 24,
  },
  titleWrapper: {
    marginBottom: 8,
  },
}));
